export function setLocalStorage(key, value) {
    const prefixedKey = `npoplayer-${key}`;
    localStorage.setItem(prefixedKey, JSON.stringify(value));
}
export function getLocalStorage() {
    const result = {};
    for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key && key.startsWith('npoplayer-')) {
            const item = localStorage.getItem(key);
            if (item !== null) {
                const originalKey = key.replace('npoplayer-', '');
                result[originalKey] = JSON.parse(item);
            }
        }
    }
    return result;
}
export function setValuesBasedOnLocalStorage(playerContext) {
    const localStorageData = getLocalStorage();
    const player = playerContext.player;
    if (!player) {
        console.error('Player is undefined in playerContext');
        return;
    }
    player.setVolume(localStorageData.volume ?? 100);
    if (localStorageData.ismuted === 'true') {
        player.mute();
    }
    if (localStorageData.subtitles_enabled === 'true') {
        playerContext.npoplayer.streamOptions.enableSubtitles = true;
    }
}
